<app-modal [textConfirmBtn]="'Accedi'" (OnConfirm)="login()" (OnCancel)="cancel()">
    <h4>Questa email ci risulta già registrata!</h4>
    <p>Inserisci la password che ti è stata inviata in fase di registrazione per procedere</p>
    <input type="text" class="form-control form-control-sm" name="password" [(ngModel)]="password"/>
    <button type="button" class="btn btn-block btn-xs btn-secondary mt-2" (click)="sendPassword()">Rinvia la password al mio indirizzo email</button>

</app-modal>
              
